module.exports = __webpack_public_path__ + "static/DPF-Spannring-b2827e0ad65f18e7f30a08ac33a19354.jpg";